import React, { Component } from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import { Card, Form, notification } from 'antd'
import Request from '../../request'
import _ from 'lodash'

import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import moment from 'moment'
import AddHoliday from './AddHoliday'

@Form.create()

class AllGovtHolidays extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    showAddTaskForm: false,
    showTaskListForm: false,
    weekendsVisible: true,
    currentEvents: [],
    allEvents: [],
  }

  deleteGovtHolidays = async data => {
    this.setState({ loading: true })
    await Request.deleteGovtHolidays(data)

    this.setState({ loading: false })

    this.reloadCalander();

    notification.success({
      message: 'Deleted Successfully',
      duration: 20,
      key: `${data._id}-close`
    })
  }
  closeDocument = () => {
    this.setState({
      showAddTaskForm: false,
      showTaskListForm: false
    })
    this.reloadCalander()
  }
  reloadCalander = () => {
    setTimeout(() => {
      this.getCalendarData({
        startStr: this.state.startDate,
        endStr: this.state.endDate
      })
    }, 400)
  }
  handleDateSelect = (selectInfo) => {
    // if(moment().isAfter(selectInfo.startStr, 'date')) {
    //   return notification.error({
    //     message: `You can't add task before today's Date`
    //   })
    // }
    this.setState({
      showAddTaskForm: true,
      currentEvent: {
        holidayDate: selectInfo.startStr
      }
    });
  }

  handleEventClick = (clickInfo) => {
    this.setState({
      showAddTaskForm: true,
      currentEvent: {
        holidayId: clickInfo.event._def.publicId,
        holidayName: clickInfo.event.title,
        holidayDate: moment(clickInfo.event.startStr).format('YYYY-MM-DD'),
        holidayType: clickInfo.event._def.extendedProps.holidayType
      }
    });
  }

  handleEvents = (events) => {
    this.setState({
      currentEvents: events
    })
  }
  getCalendarData = async (dates) => {
    let startDate = (dates.startStr)
    let endDate = (dates.endStr)

    this.setState({ startDate, endDate })
    let params = {};

    params["holidayDate"] = {
      $gte: startDate,
      $lte: endDate
    };

    let response = await Request.getGovtHolidays(params);
    let events = [];
    _.each(response.data, (event) => {
      events.push({
        id: event._id,
        title: event.holidayName,
        start: event.holidayDate,
        holidayType: event.holidayType
      })
    })
    this.setState({ allEvents: events });
  }

  eventAddHandler = async (event) => {
  }

  renderEventContent = (eventInfo) => {
    let bgColor = '#ed1c24';
    if (eventInfo.event._def.extendedProps.holidayType === 'Paid') {
      bgColor = 'green';
    }
    return (
      <div title={eventInfo.event.title} style={{ backgroundColor: bgColor, padding: '2px', color: 'white' }}>
        <i>{eventInfo.event.title}</i>
      </div>
    )
  }
  refreshFxn = () => {
    this.setState({ refreshChild: !this.state.refreshChild })
  }

  componentWillMount() {

  }

  async componentDidMount() {
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
      activeTab: value
    })
  }
  render() {
    // const {
    //   form: {getFieldDecorator, setFieldsValue}
    // } = this.props
    const { currentEvent, showAddTaskForm, allEvents } = this.state;

    return (
      <PageHeaderWrapper title={` Holiday Calendar `}>
        {
          showAddTaskForm ?
            <AddHoliday currentEvent={currentEvent} onClose={this.closeDocument} />
            : null
        }
        <Card bordered={true}>
          <FullCalendar
            plugins={[
              dayGridPlugin,
              timeGridPlugin,
              interactionPlugin
            ]}
            headerToolbar={{
              left: 'prev,next today',
              center: 'title',
              right: 'dayGridMonth,timeGridWeek,timeGridDay'
            }}
            datesSet={data => {
              this.getCalendarData(data);
            }}
            initialView='dayGridMonth'
            editable={true}
            selectable={true}
            selectMirror={true}
            dayMaxEvents={true}
            weekends={this.state.weekendsVisible}
            forceEventDuration={true}
            events={allEvents}
            eventContent={this.renderEventContent}
            select={this.handleDateSelect}
            eventClick={this.handleEventClick}
            eventsSet={this.handleEvents}
          />
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllGovtHolidays
